import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { Platform } from '@ionic/angular';
import { CapacitorCookies } from '@capacitor/core';

export enum SameSite {Strict = 'Strict', Lax = 'Lax', None = 'None',}

export type CookieOpts = {
    path?: string,
    expires?: Date,
    sameSite?: SameSite
    secure?: boolean,
    domain?: string
}

@Injectable({
    providedIn: 'root'
})
export class CookiesService {
    constructor(
        private readonly cookies: CookieService,
        private readonly platform: Platform,
    ) {
    }

    async set(name: string, value: string, opts?: CookieOpts) {
        if (this.platform.is('hybrid')) {
            await CapacitorCookies.setCookie({
                key: name,
                value,
                url: opts?.domain,
                path: opts?.path || '/'
            });
        } else {
            this.cookies.set(name, value, opts);
        }
    }

    async deleteAll(path: string, domain?: string) {
        if (this.platform.is('hybrid')) {
            await CapacitorCookies.clearAllCookies();
        } else {
            this.cookies.deleteAll(path, domain);
        }
    }

    async get(name: string) {
        if (this.platform.is('hybrid')) {
            const cookies = await CapacitorCookies.getCookies();
            return cookies[name];
        }
        return this.cookies.get(name);
    }
}
